var _excluded = ["selectProps"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { components } from 'react-select';
import { Button } from "../..";
export var DropdownIndicator = function DropdownIndicator(_ref) {
  var selectProps = _ref.selectProps,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var menuIsOpen = selectProps.menuIsOpen,
      hideDropdownIndicator = selectProps.hideDropdownIndicator;

  if (hideDropdownIndicator) {
    return null;
  }

  return /*#__PURE__*/React.createElement(components.DropdownIndicator, restProps, /*#__PURE__*/React.createElement(Button, {
    appearance: "icon",
    size: "small",
    icon: menuIsOpen ? 'arrow_chevron_down' : 'arrow_chevron_up'
  }));
};